CatalogCreateModalController.$inject= ['CatalogService'];
export default function CatalogCreateModalController(CatalogService) {
    var ctrl = this;

    ctrl.$onInit = function() {
        ctrl.profiles = [
            {name: "RUSMARC", value:"dom.rusmarc"}, 
            {name: "RUSMARC (catalogue)", value:"dom.rusmarc.catalogue"} 
        ];
    };

    ctrl.content = {
        type: 'dom.rusmarc'
    };

    ctrl.isSuccess = false;
    ctrl.isProcess = false;
    ctrl.isError = false;

    ctrl.create = function() {
        ctrl.isProcess = true;
        CatalogService.save({}, ctrl.content).$promise.then(function(response) {
            if (response.success) {
                ctrl.response = response;
                ctrl.isSuccess = true;
            } else {
                ctrl.isError = true;
            }
            ctrl.isProcess = false;
        }, function(error) {
            console.log(error);
            ctrl.isError = error;
            ctrl.isProcess = false;
        });
    };

    ctrl.ok = function() {
        ctrl.modalInstance.close(ctrl.content);
    };

    ctrl.cancel = function() {
        ctrl.modalInstance.dismiss("cancel");
    };
}
